export default __webpack_public_path__ + "static/media/calendar-icon.d3b61f02.svg";